
<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle *ngIf="messageHeader">
  <h5 class="modal-title">{{messageHeader}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body text-center">
  <p class="fw-semibold" *ngIf="popupText1">{{popupText1}}</p>
  <p *ngIf="popupText2">{{popupText2}}</p>
</div>

<div class="modal-footer justify-content-center">
  <button type="button" class="btn btn-success" (click)="ok()">OK</button>
</div>